module.exports = __webpack_public_path__ + "static/media/layer_8.3acdd33d.png";